export default function({ app, error, store }) {
  const isRoleApplication = store.state.frontend.auth.user.is_role_application

  if (!isRoleApplication) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー',
    })
  }
}
